const localcache = {
  BASE_DATA: 'BASE_DATA',
  CONST_DATA: 'CONST_DATA',
  CONST_MD5: 'CONST_MD5',
  BASE_DATA_MD5: 'BASE_DATA_MD5',
  ENT_INSERT: 'ENT_INSERT',
  SHOP_INSERT: 'SHOP_INSERT',
  CITY_INSERT: 'CITY_INSERT',
  SET_ROLES: 'SET_ROLES',
  SET_NAME: 'SET_NAME',
  SET_ACCOUNT: 'SET_ACCOUNT',
  SET_AVATAR: 'SET_AVATAR',
  SET_NOTICE_COUNT: 'SET_NOTICE_COUNT',
  WORKER_INSERT: 'WORKER_INSERT',
  COMPANY_DATA:'COMPANY_DATA',
  
  get: function(key) {
    return JSON.parse(localStorage.getItem(key))
  },
  getArrInData: function(key) {
    const arr= JSON.parse(localStorage.getItem(key))
    if(!arr){
      return []
    }
    return arr.data
  },
  getObjInData: function(key) {
    const obj = JSON.parse(localStorage.getItem(key))
    if(!obj){
      return {}
    }
    return obj.data
  },
  getArr: function(key) {
    const arr= JSON.parse(localStorage.getItem(key))
    if(!arr){
      return []
    }
    return arr
  },
  getObj: function(key) {
    const obj = JSON.parse(localStorage.getItem(key))
    if(!obj){
      return {}
    }
    return obj
  },
  getStr: function(key) {
    const str = JSON.parse(localStorage.getItem(key))
    if(!str){
      return ''
    }
    return str
  },
  set: function(key, value) {
    if (value) {
      localStorage.setItem(key, JSON.stringify(value))
    } else {
      localStorage.removeItem(key)
    }
  },
  remove: function(key) {
    localStorage.removeItem(key)
  }
}

export default localcache



// WEBPACK FOOTER //
// ./src/common/localcache.js